vec3 effect(vec2 uv)
{
    return floor(sampleCam(uv) * uLevels) / uLevels;
}
